// extracted by mini-css-extract-plugin
module.exports = {"default":"CTA-module__default___1UIkE","small":"CTA-module__small___1CvMl","responsive":"CTA-module__responsive___3NKBf"};